export enum CartErrorEnum {
  CART_ITEM_ALREADY_IN_ANOTHER_RULE = 'CART_ITEM_ALREADY_IN_ANOTHER_RULE',
  CART_NOT_FOUND = 'CART_NOT_FOUND',
  CART_NOT_OPEN = 'CART_NOT_OPEN',
  PRODUCT_NOT_EXIST_IN_CART = 'PRODUCT_NOT_EXIST_IN_CART',
  CART_NOT_VALID = 'CART_NOT_VALID',
  ITEM_ERROR_MINIMUM_AMOUNT = 'ITEM_ERROR_MINIMUM_AMOUNT',
  ITEM_ERROR_MAX_AMOUNT = 'ITEM_ERROR_MAX_AMOUNT',
}